<template>
  <div class="app-wrapper">
    <!-- <linkbar></linkbar> -->
    <div class="header">
      <div>
        <p class="address-logo cursor fs18">
          {{ user && user.areaName }}共享单车监管平台
        </p>
        <ul>
          <li
            @click="onHeader"
            :class="{ curr: currpath.indexOf('/dailyDuty') > -1 }"
            v-show="checkUserAuth(2, null)"
          >
            <router-link :to="dailyDutyUrlComputed" tag="a"
              >日常值守</router-link
            >
          </li>
          <li
            @click="onHeader"
            :class="{ curr: currpath.indexOf('/operation') > -1 }"
            v-show="checkUserAuth(64, null)"
          >
            <router-link :to="operationUrlComputed" tag="a"
              >运营统计</router-link
            >
          </li>
          <li
            @click="onHeader"
            :class="{ curr: currpath.indexOf('/miBicycle') > -1 }"
            v-show="checkUserAuth(72, null)"
          >
            <router-link :to="miBicycleManagementUrlComputed" tag="a"
              >智慧e骑行</router-link
            >
          </li>
            <li
            @click="onHeader"
            :class="{ curr: currpath.indexOf('/ratingEvaluation') > -1 }"
            v-show="checkUserAuth(5, null)"
          >
            <router-link :to="ratingEvaluationUrlComputed" tag="a"
              >评分评价</router-link
            >
          </li>
                 <li
            @click="onHeader"
            :class="{ curr: currpath.indexOf('/deviceManagement') > -1 }"
            v-show="checkUserAuth(3, null)"
          >
            <router-link :to="deviceManagementUrlComputed" tag="a"
              >站点管理</router-link
            >
          </li>
          <li
            @click="onHeader"
            :class="{ curr: currpath.indexOf('/companyManagement') > -1 }"
            v-show="checkUserAuth(4, null)"
          >
            <router-link :to="companyManagementUrlComputed" tag="a"
              >企业管理</router-link
            >
          </li>
          <li
            @click="onHeader"
            :class="{ curr: currpath.indexOf('/inforManagement') > -1 }"
            v-show="checkUserAuth(5, null)"
          >
            <router-link :to="inforManagementUrlComputed" tag="a"
              >资料管理</router-link
            >
          </li>
          <!-- <li @click="onHeader" :class="{'curr': currpath.indexOf('/systemSettings')>-1}" v-show="checkUserAuth(6, null)">
            <router-link
              :to="systemSettingsUrlComputed"
              tag="a"
            >系统设置</router-link>
          </li> -->
          <li
            @click="onHeader"
            :class="{ curr: currpath.indexOf('/regionalSettings') > -1 }"
            v-show="checkUserAuth(6, null)"
          >
            <router-link :to="regionalSettingsUrlComputed" tag="a"
              >系统设置</router-link
            >
          </li>
        </ul>
      </div>
      <div class="hd_right">
        <div class="relative">
          <el-dropdown @command="handleCommand" v-if="Number(userLevel) === 2">
            <span class="el-dropdown-link">
              <el-badge
                v-if="siteMessageLength"
                v-show="checkUserAuth(7, 8)"
                :value="siteMessageLength"
                class="item">
                <i class="iconfont icon-tixing" style="font-size: 32px;color: #ffffff;"></i>
              </el-badge>
              <template v-else v-show="checkUserAuth(7, 8)">
                <i class="iconfont icon-tixing" style="font-size: 32px;color: #ffffff;"></i>
              </template>
              <i v-show="!checkUserAuth(7, 8)" class="iconfont icon-tixing" style="font-size: 32px;color: #ffffff;"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="4" v-show="checkUserAuth(7, 9)">
                <div class="abnormal-one-line">
                  <span>异常告警</span>
                  <span class="blue">历史详情</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item
                :command="'abnormal' + item.id"
                v-for="item in historyData"
                :key="'abnormal' + item.id"
              >
                <div class="abnormal-box">
                  <div class="abnormal-name">
                    <span>{{ item.brandName }}</span>
                    <span class="t">{{
                      item.updateTime | dateFormat("yyyy-MM-dd hh:mm")
                    }}</span>
                  </div>
                  <div class="abnormal-site">
                    {{ item.siteName }}
                    <span class="red">{{
                      getAbnormalType(item.abnormalType)
                    }}</span>
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="iconfont icon-touxiang" style="font-size: 32px;color: #ffffff;"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1" v-if="user">
                <i class="iconfont icon-gerentouxiang_o" style="font-size: 25px;color: #000000;"></i>
                <div style="float: right;margin-top: 2px;margin-right: 15px;">{{ user.name }}</div>
              </el-dropdown-item>
              <el-dropdown-item command="2">
                <i class="iconfont icon-ico_xiugaimima" style="font-size: 25px;color: #000000;"></i>
                修改密码
              </el-dropdown-item>
              <el-dropdown-item command="3">
                <i class="iconfont icon-tuichudenglu" style="font-size: 25px;color: #000000;"></i>
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!-- 左侧菜单 -->
    <div class="aside-left" >
      <div class="container">
        <SideBar />
      </div>
    </div>
    <!-- 历史警告 -->
    <div class="abnormal-history-layout" v-if="historyShow">
      <div class="abnormal-history">
        <abnormal-history
          ref="abnormalHistory"
          :companyData="tableDataBrands"
          @jjSearchFromHistory="jjSearchFromHistory"
          @closeHistory="historyShow = false"
        />
      </div>
    </div>
    <template v-if="user">
      <div class="main-container">
        <app-main ref="app-main"></app-main>
      </div>
    </template>
    <template v-else>
      <no-permission />
    </template>
    <!-- 弹窗 -->
    <w-dialog
      ref="w-dialog"
      :title="dialogTitle"
      :width="width"
      :isShowFooter="isShowFooter"
      @handleClose="handleClose"
      @handleCloseRight="handleClose"
      @onSure="onSure"
    >
      <template v-slot:content>
        <!-- 用户信息 -->
        <div v-if="type === '1'">
          <text-list-slot>
            <ul>
              <li>
                <span>登录账号：</span>
                <span>{{ user.username }}</span>
              </li>
              <li>
                <span>姓名：</span>
                <span>{{ user.name }}</span>
              </li>
              <li>
                <span>联系电话：</span>
                <span>{{ user.phone }}</span>
              </li>
              <li>
                <span>工作单位：</span>
                <span>{{ user.company }}</span>
              </li>
            </ul>
            <ul>
              <li>
                <span>角色类型：</span>
                <span>{{
                  user.roles && user.roles[0] && user.roles[0].roleName
                }}</span>
              </li>
              <li>
                <span>权限区域：</span>
                <span>{{ user.areaName || "全国" }}</span>
              </li>
              <li>
                <span>使用时效：</span>
                <span
                  >{{ user.createTime | dateFormat("yyyy-MM-dd") }}至{{
                    user.unavailableTime | dateFormat("yyyy-MM-dd")
                  }}</span
                >
              </li>
              <li class="mt10">
                <span style="vertical-align: top">身份证照：</span>
                <span>
                  <el-image
                    style="width: 100px; height: 100px; margin-right: 10px"
                    :src="user.idcardUrl | filterImage"
                    :preview-src-list="[
                      filterImage(user.idcardUrl),
                      filterImage(user.idcardBackUrl),
                    ]"
                  >
                  </el-image>
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="user.idcardBackUrl | filterImage"
                    :preview-src-list="[
                      filterImage(user.idcardBackUrl),
                      filterImage(user.idcardUrl),
                    ]"
                  >
                  </el-image>
                </span>
              </li>
            </ul>
            <ul>
              <li>
                <span>创建人：</span>
                <span>{{ user.name }}</span>
              </li>
              <li>
                <span>角色类型：</span>
                <span>{{
                  user && user.roles && user.roles[0] && user.roles[0].roleName
                }}</span>
              </li>
              <li>
                <span>创建时间：</span>
                <span>{{ user.createTime | dateFormat("yyyy-MM-dd") }}</span>
              </li>
            </ul>
          </text-list-slot>
        </div>
        <!-- 修改密码 -->
        <div v-if="type === '2'">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="旧密码：" prop="oldPass" style="width: 50%">
              <el-input
                type="password"
                v-model="ruleForm.oldPass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="新密码：" prop="newPass" style="width: 50%">
              <el-input
                type="password"
                v-model="ruleForm.newPass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import NoPermission from '@/views/Other/401.vue'
import Sidebar2 from './sidebar2'
import AbnormalHistory from './abnormal-history'
import AppMain from './appMain'
import { mapGetters } from 'vuex'
import store from '../../store'
import Api from '@/api'
import WDialog from '@/components/Model/index.vue'
import TextListSlot from '@/components/Listbox/textListSlot.vue'
import { filterImage } from '@/utils/tools'
import SideBar from '@/views/Layout/sidebar2'
export default {
  name: 'layout',
  data() {
    return {
      dailyDutyUrl: '/index',
      deviceManagementUrl: '/deviceManagement',
      companyManagementUrl: '/companyManagement/company',
      inforManagementUrl: '/inforManagement',
      systemSettingsUrl: '/systemSettings',
      regionalSettingsUrl: '/regionalSettings',
      operationUrl: '/operation',
      miBicycleManagementUrl: '/miBicycle',
      ratingEvaluationUrl: '/ratingEvaluation',
      historyShow: false,
      tableData: [],
      dialogTitle: '',
      width: '50%',
      type: '',
      isShowFooter: true,
      ruleForm: {
        oldPass: '',
        newPass: ''
      },
      rules: {
        oldPass: [{ validator: this.validateOldPass, trigger: 'blur' }],
        newPass: [{ validator: this.validateNewPass, trigger: 'blur' }]
      },
      pinFenUrl: 'http://ydkh.gxdcjg.com'
    }
  },
  computed: {
    ...mapGetters([
      'currpath',
      'user',
      'globaleSelfAreaId',
      'siteMessage',
      'selfAreaId',
      'siteMessageLength',
      'userLevel',
      'historyData',
      'tableDataBrands'
    ]),
    selfAreaId() {
      if (this.userLevel < 2) {
        return ''
      } else {
        return this.$store.getters.selfAreaId
      }
    },
    isAggregation() {
      // 是否是非复合区下的实体区
      return (
        (this.aggregation == 0 && this.aggregationId == '') ||
        (this.aggregation == 1 && this.aggregationId)
      )
    },
    aggregationId() {
      // 实体区的复合区Id
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregationId
        : undefined
    },
    aggregation() {
      // 0 - 实体区
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregation
        : undefined
    },
    secondUrlParams() {
      const data = this.currpath.split('/').pop()
      return isNaN(data) ? '' : ('/' + data)
    },
    ratingEvaluationUrlComputed() {
      return this.ratingEvaluationUrl + this.secondUrlParams
    },
    dailyDutyUrlComputed() {
      return this.dailyDutyUrl + this.secondUrlParams
    },
    operationUrlComputed() {
      return this.operationUrl + this.secondUrlParams
    },
    deviceManagementUrlComputed() {
      return this.deviceManagementUrl + this.secondUrlParams
    },
    companyManagementUrlComputed() {
      return this.companyManagementUrl + this.secondUrlParams
    },
    inforManagementUrlComputed() {
      return this.inforManagementUrl + this.secondUrlParams
    },
    systemSettingsUrlComputed() {
      return this.systemSettingsUrl + this.secondUrlParams
    },
    regionalSettingsUrlComputed() {
      return this.regionalSettingsUrl + this.secondUrlParams
    },
    miBicycleManagementUrlComputed() {
      return this.miBicycleManagementUrl + this.secondUrlParams
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  created() {
    this.getCompany()
    if (this.$route.name == 'warn') {
      this.abnormalHistoryShow()
    }
  },
  methods: {
    init() {
      this.getArea()
    },
    async getArea() {
      // 判断复合区有没有企业 如果没有企业 就获取上级的id
      if (!this.selfAreaId) {
        this.areaId = this.selfAreaId
        this.toDo = {}
      }
      const vm = this
      const hasLength = await vm.getEnterpriseListAndHasLength()
      if (!this.selfAreaId) {
        this.Loading = false
        return
      }
      if (!hasLength && vm.aggregation === 0) {
        vm.areaId = vm.aggregationId
      } else {
        vm.areaId = vm.selfAreaId
      }
      Api.getPendEvent({
        areaId: this.areaId,
        selfAreaId: this.selfAreaId
      }).then((res) => {
        this.Loading = false
        this.toDo = res.data
      })
    },
    async getEnterpriseListAndHasLength() {
      try {
        return new Promise((resolve) => {
          Api.getEnterpriseList({ selfAreaId: this.selfAreaId })
            .then((res) => {
              if (res.code === 200 && res.data && res.data.total) {
                resolve(true)
              } else {
                resolve(false)
              }
            })
            .catch((err) => {
              resolve(false)
              console.log('the getEnterpriseList has probleam: ', err)
            })
        })
      } catch (e) {
        console.log('the getEnterpriseList has probleam: ', e)
      }
    },
    toWeb() {
      window.open(this.pinFenUrl)
    },
    onBuild() {
      this.$notify({
        type: 'warning',
        title: '提示',
        message: '请联系管理员开通权限',
        duration: 1000
      })
    },
    onHeader() {
      this.historyShow = this.historyShow && false
    },
    filterImage(url) {
      return filterImage(url)
    },
    validateOldPass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入旧密码'))
      } else {
        // if (this.ruleForm.checkPass !== '') {
        //   this.$refs.ruleForm.validateField('checkPass')
        // }
        callback()
      }
    },
    validateNewPass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else
      if (!/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/.test(value)) {
        callback(new Error('密码必须包含大写字母 、数字、 特殊字符（四种里至少三种，且至少8位）'))
      } else {
        // if (this.ruleForm.checkPass !== '') {
        //   this.$refs.ruleForm.validateField('checkPass')
        // }
        callback()
      }
    },
    handleClose() {
      this.dialogTitle = ''
      this.isShowFooter = true
      this.$refs['w-dialog'].onCloseDialog()
    },
    onSure() {
      const vm = this
      vm.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const params = {
            selfAreaId: vm.selfAreaId
          }
          const data = {
            oldPwd: vm.ruleForm.oldPass,
            newPwd: vm.ruleForm.newPass
          }
          Api.pwd(data, params).then((res) => {
            if (res.code === 200) {
              vm.$message.success('密码修改成功！')
              vm.handleClose()
            } else {
              vm.$message.warning(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
    jjSearch(bikeId) {
      this.historyShow = false
      this.$refs['app-main'].$children[0].jjSearch({ bikeId: bikeId })
    },
    jjSearchFromHistory(item) {
      this.historyShow = false
      this.$refs['app-main'].$children[0].jjSearchFromHistory(item)
    },
    getCompany() {
      const vm = this
      const params = {}
      params.selfAreaId = this.selfAreaId
      Api.getEnterpriseList(params).then((res) => {
        if (res.code === 200) {
          // vm.tableData = res.data.lists
          const brands = JSON.parse(JSON.stringify(res.data.lists))
          if (brands && brands.length) {
            brands.forEach((item) => {
              item.key = item.brandId
              item.value = item.brandName
            })
            store.commit('globalVariable/save', {
              key: 'brands',
              value: brands
            })
          } else {
            store.commit('globalVariable/save', {
              key: 'brands',
              value: []
            })
          }
          // vm.getMsgCounts()
          // vm.getMsg()
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    abnormalHistoryShow() {
      // this.siteMessageLength = 0
      this.historyShow = true
      this.updateMsg()
      // const getCompanyParams = {
      //   selfAreaId: this.selfAreaId
      // }
      // store.dispatch('globalVariable/getCompany', getCompanyParams)
    },
    updateMsg() {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.updateMsg(params).then((res) => {
        if (res.code === 200) {
          // vm.siteMessageLength = res.data
          const userSiteMessageLength = {
            key: 'siteMessageLength',
            value: 0
          }
          store.commit('user/setUserInfo', userSiteMessageLength)
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    getMsgCounts() {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.getMsgCounts(params).then((res) => {
        if (res.code === 200) {
          vm.siteMessageLength = res.data
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    getMsg() {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.getMsg(params).then((res) => {
        if (res.code === 200) {
          vm.historyData =
            res.data.lists && res.data.lists.length > 5
              ? res.data.lists.slice(0, 4)
              : res.data.lists
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    handleCommand(command, item) {
      this.type = command
      switch (command) {
        case '1':
          this.showUserInfo()
          break
        case '2':
          this.handleEditPassword()
          break
        case '3':
          this.onLogout()
          break
        case '4': // 异常警告 - 历史详情
          this.abnormalHistoryShow()
          break
      }
    },
    showUserInfo() {
      this.dialogTitle = '用户信息'
      this.isShowFooter = false
      this.$refs['w-dialog'].onShowDialog()
    },
    handleEditPassword() {
      this.dialogTitle = '修改密码'
      this.isShowFooter = true
      this.$refs['w-dialog'].onShowDialog()
    },
    onLogout() {
      const vm = this
      const text = '你是否确定退出登录？'
      const textTitle = '温馨提示'
      vm.$confirm(text, textTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 获取用户登录设备
          const device = this.getLoginDevice()
          const params = {
            selfAreaId: this.selfAreaId
          }
          const data = {
            operationDevice: device,
            userName: this.user.username,
            userId: this.user.id
          }
          Api.logout(params, data).then((res) => {
            if (res.code === 200) {
              store.dispatch('user/logout').then(() => {
                vm.$router.push('/login')
              })
            } else {
              vm.$message.warning(res.message)
            }
          })
        })
        .catch(() => {})
    },
    getAbnormalType(type) {
      return {
        1: '违规还车',
        2: '违法设备',
        3: '超时未还',
        4: '异常站点',
        5: '故障车辆'
      }[String(type)]
    }
  },
  components: {
    Sidebar2,
    AppMain,
    NoPermission,
    AbnormalHistory,
    WDialog,
    TextListSlot,
    SideBar
  }
}
</script>

<style lang="less">
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 201;
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(62, 119, 241, 1) 0%,
    rgba(56, 168, 243, 1) 100%
  );
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  width: 100%;
  color: #fff;
  .address-logo {
    width: 500px;
    padding-left: 50px;
    background-image: url("../../assets/logo.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left;
    background-position: 15px 0;
  }
  ul {
    display: block;
    width: 100%;
    height: 56px;
    margin: 0;
    padding: 0;
    list-style: none;
    li {
      box-sizing: border-box;
      float: left;
      height: 56px;
      line-height: 56px;
      margin: 0;
      padding: 0 20px;
      color: #fff;
      cursor: pointer;
      font-size: 14px;
      a {
        display: inline-block;
        width: 100%;
        height: 100%;
        text-decoration: none;
        color: #fff;
      }
    }
    li:hover,
    .curr {
      background-color: #3e77f1;
    }
    .curr {
      // width: 180px;
      text-align: center;
      cursor: auto;
      color: #fff;
    }
  }
  > div {
    align-items: center;
    display: flex;
  }
  .hd_right {
    div {
      width: 28px;
      height: 28px;
      margin-right: 24px;
      img {
        width: 100%;
      }
    }
    .circle-tips {
      display: inline-block;
      text-align: center;
      padding: 2px 4px;
      background: red;
      color: #fff;
      font-size: 12px;
      position: absolute;
      top: 0px;
      left: 20px;
      line-height: 1;
      border-radius: 50%;
    }
  }
}
.abnormal-history-layout {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transition: all 0.28s ease-out;
  margin-top: 56px;
  box-sizing: border-box;
  z-index: 1;
  .abnormal-history {
    background: #f0f2f5;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
  }
}
.abnormal-one-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  line-height: 1;
  box-sizing: border-box;
  min-width: 300px;
  span {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(111, 117, 128, 1);
  }
  span.blue {
    font-size: 12px;
  }
}
.abnormal-box {
  border-top: 1px solid #ebebeb;
  padding: 16px 0;
  min-width: 300px;
  .abnormal-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1;
    span {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.65);
    }
    span.t {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.25);
    }
  }
  .abnormal-site {
    margin-top: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 1;
    span {
      margin-left: 8px;
    }
  }
}
.app-wrapper {
  &:after {
    content: "";
    display: table;
    clear: both;
  }
  position: relative;
  height: 100%;
  width: 100%;
  &.hideSidebar {
    .sidebar-wrapper {
      transform: translate(-140px, 0);
      .sidebar-container {
        transform: translate(132px, 0);
      }
      &:hover {
        transform: translate(0, 0);
        .sidebar-container {
          transform: translate(0, 0);
        }
      }
    }
  }
  .aside-left {
    width: 180px;
    height: 100vh;
    background: white;
    position: fixed;
    left: 0;
    top: 0;
    transform: translateX(-100%);
    transition: all 0.3s;
    z-index: 22;
    .container {
      height: 100vh;
      overflow: auto;
    }
    &:hover {
      transform: translateX(0);
    }
    &::after {
      content: "";
      background: url("~@/assets/image/按钮.png") no-repeat center;
      background-size: contain;
      width: 20px;
      height: 211px;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(100%, -50%);
    }
  }
  .main-container-header {
    margin-left: 180px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
  }
  .main-container {
    transition: all 0.28s ease-out;
    margin-left: 180px;
    // margin-top: 56px;
    box-sizing: border-box;
    // padding: 20px;
    // background:rgba(240,242,245,1);
  }
  .el-badge__content {
    border: none;
  }
}
</style>
